import { Record } from 'immutable'

export class VehicleFleetboardConfiguration extends Record({
    id: undefined,
    number: undefined,
    name: undefined,
    description: undefined,
}) {}
